import QRCode from "qrcode";

export async function renderQr(text: string, size = 96): Promise<string> {
  const styles = getComputedStyle(document.documentElement);
  const dark = styles.getPropertyValue("--ink").trim() || "#1A1410";
  const light = styles.getPropertyValue("--surface").trim() || "#FFFFFF";
  return QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    errorCorrectionLevel: "M",
    color: { dark, light },
  });
}
